import TIM from 'tim-js-sdk'
import axios from 'axios'
import { INTERACTION_HOSTNAME } from 'common/utils/variables'
import adapter from './adapter'
import {loginApp, getUrlParam} from '../../../common/js/common'
import logger from '../../../base/logger'

const ax = axios.create({
  baseURL: `${INTERACTION_HOSTNAME}/interactionCommon/`
})
const axDirect = axios.create({
  baseURL: `${INTERACTION_HOSTNAME}/interactionDirectCall/`
})
ax.defaults.withCredentials = axDirect.defaults.withCredentials = true
const responseInterceptor = response => {
  const appBridge = window.appBridge;
  const { data, success, code, info } = response.data;
  if (success) {
    return data;
  }
  if (code === 401 && appBridge && appBridge.isApp()) {
    loginApp();
  } else {
    return Promise.reject(new Error(code + ": " + info));
  }
};
ax.interceptors.response.use(responseInterceptor)
axDirect.interceptors.response.use(responseInterceptor)

adapter.install(TIM)
adapter.quitPresentation = function quitPresentation (andInvalidateRoom = true) {
  const {pbUuid, roomId} = this.pageContext
  if (!roomId || !this.dashboard.isInGroup) {
    return
  }
  this.stopAudioChat()
  if (andInvalidateRoom) {
    ax.get("endInteractionByUser", { params: { pbUuid } });
  }
  this.quitGroup()
  // this.logout()
  Object.assign(this.dashboard, {
    isLogin: false,
    isInGroup: false
  });
  this.pageContext.roomId = null
}
adapter.requestPresenterControl = function requestPresenterControl () {
  // TODO: 对接服务端接口，call ax.post('someApi')
  const appBridge = window.appBridge
  const {pbUuid, salesUuid, roomId} = this.pageContext
  const agentSite = appBridge && appBridge.isApp()
  ax.post("getControl", { agentSite, salesUuid, pbUuid, groupId: roomId });
}
adapter.startAudioChat = async function startAudioChat (messageHandler) {
  if (this.dashboard.isAudioConnected) {
    logger.warn('重复开启音频')
    return true
  }
  logger.warn('[TRTC]', '检查 appBridge 版本')
  const appBridge = window.appBridge
  if (appBridge && appBridge.isApp() && appBridge.checkAppFeature('TRTC_ENTER_ROOM')) {
    const { userId, sdkAppId, userSig, roomId } = this.pageContext
    logger.warn('[TRTC]', '即将进入 TRTC 房间', this.pageContext)
    appBridge.$on("app:trtcMessage", trtcMsg => {
      logger.warn('[TRTC]', 'trtcMsg: ', trtcMsg)
      if (typeof messageHandler === 'function') {
        messageHandler(trtcMsg)
      }
    });

    try {
      const returnCode = await appBridge.trtcEnterRoom({ userId, roomId, sdkAppId, userSig }).then(({result}) => {
        console.warn('[appBridge],', 'trtcEnterRoom', result)
      }).catch(e => {
        console.warn('[appBridge],', 'trtcEnterRoom error', e.message)
      })
      logger.warn('[TRTC]', '进房成功：', returnCode)
      logger.warn('[TRTC]', '房号：', roomId)
    } catch(e) {
      logger.warn('[TRTC]', '进房异常：', e)
      throw e
    }
    console.warn('[TRTC]', 'startAudioChat end')
    this.dashboard.isAudioConnected = true
    return true
  }
  throw new Error('APP_VERSION_NOT_SUPPORT_TRTC')
}
adapter.stopAudioChat = function stopAudioChat () {
  if (!this.dashboard.isAudioConnected) {
    logger.warn('音频未初始化成功无需销毁。或重复销毁音频')
    return
  }
  const appBridge = window.appBridge
  if (appBridge && appBridge.isApp() && appBridge.checkAppFeature('TRTC_EXIT_ROOM')) {
    appBridge.trtcExitRoom()
    this.dashboard.isAudioConnected = false
  }
  return this
}
adapter.muteLocal = function muteLocal (isOn = false) {
  const appBridge = window.appBridge
  if (appBridge && appBridge.checkAppFeature('TRTC_TOGGLE_LOCAL_AUDIO')) {
    appBridge.trtcToggleLocalAudio({isOn})
  }
  return this
}

export async function initTim (avatar, nick, salesUuid, interactionType) {
  const tim = adapter
  tim.dashboard = {
    isLogin: false,
    isInGroup: false,
    isAudioConnected: false,
    isSdkReady: false
  }

  // TODO: 调试用
  window.theTim = tim

  const sdkReadyPromise = new Promise(resolve => {
    tim.on(tim.EVENTS.onSdkReady, resolve)
  })

  const { userSig, sdkAppId, userId } = await ax.get('userSig/get/')
  tim.create(sdkAppId)
  await tim.login(userId, userSig)
  tim.dashboard.isLogin = true

  const pbUuid = getUrlParam('uuid')

  let roomId = getUrlParam('roomId')
  if (roomId) {
    logger.warn('[TIM INIT]', 'roomId: ', roomId)
    await axDirect.get("directStartForUser", {
      params: {
        pbUuid,
        groupId: roomId,
        interactionType
      }
    });
  } else {
    logger.warn('[TIM INIT]', 'URL roomId 参数为空')
    throw new Error("INVALID_ROOMID");
  }

  tim.pageContext = { pbUuid, sdkAppId, userId, userSig, avatar, nick, roomId, salesUuid }

  await sdkReadyPromise
  tim.dashboard.isSdkReady = true

  await tim.updateMyProfile({ avatar, nick })

  await tim.joinGroup(String(roomId))
  tim.dashboard.isInGroup = true

  return tim
}
